import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[acsStopPropagation]'
})
export class StopPropagationDirective {
  @Input() preventDefault = false;

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.stopPropagation();

    if (this.preventDefault) {
      event.preventDefault();
    }
  }
}
